/* eslint-disable */


let header = document.querySelector('#header');

window.onscroll = () => {
  const scroll = document.documentElement.scrollTop || document.body.scrollTop || 0
  if (scroll > 30) {
    if (!header.classList.contains('scrolled')) {
      header.classList.add('scrolled')
    }
  } else {
    if (header.classList.contains('scrolled')) {
      header.classList.remove('scrolled')
    }
  }
}

document.querySelector('.link_pdf > a').setAttribute('target', '__blank');


const menuMobile = document.querySelector('.menu-mobile');
const hamburger = document.querySelector('.hamburger-link');
const closeBtn = document.querySelector('.close-btn');
const body = document.querySelector('body');

const allSubMenus = document.querySelectorAll('.menu-mobile .responsive-wrapper .sub-menu');
allSubMenus.forEach(submenu => {
  const subMenuLink = document.createElement('a');
  subMenuLink.setAttribute('href', '#');
  subMenuLink.setAttribute('class', 'responsive-menu-go-back-btn');
  subMenuLink.appendChild(document.createTextNode('Retour'));
  submenu.appendChild(subMenuLink);

})


hamburger.onclick = function () {
  menuMobile.classList.add('opened');
  body.classList.add('no-scroll');
  const menuTitle = document.querySelector('.submenu-title');

  document.querySelector('#menu-primary_mobile').addEventListener('click', e => {

    const subMenu = e.target.nextElementSibling;
    const isGobackClicked = e.target.classList.contains('responsive-menu-go-back-btn');
    const menuPrimaryMobile = e.target.parentNode.parentNode.parentNode.classList.contains('responsive-menu')

    if (subMenu) {
      subMenu.classList.contains('sub-menu') && subMenu.classList.add('show-mobile-sub-menu');
      menuTitle.textContent = e.target.textContent;
    }

    if (isGobackClicked) {
      e.target.parentNode.classList.remove('show-mobile-sub-menu');
      menuTitle.textContent = e.target.parentNode.parentNode.parentNode.parentNode.querySelector('a').textContent;
      if (menuPrimaryMobile) menuTitle.textContent = '';
    }

  })


  closeBtn.onclick = function () {

    menuMobile.classList.remove('opened');
    body.classList.remove('no-scroll');
    menuTitle.textContent = '';

    allSubMenus.forEach(submenu => {
      if (submenu.classList.contains('show-mobile-sub-menu')) submenu.classList.remove('show-mobile-sub-menu');
    })
  }

}

const responsiveSearchIcon = document.querySelector('.search-form-wrapper .icon');
const mobileSubmitBtn = document.querySelector('.nav-responsive .submitBtn');

responsiveSearchIcon.onclick = function () {
  mobileSubmitBtn.click();
}


const lastMobileFirstMenuItem = document.querySelector('.menu-mobile>.nav-responsive .responsive-menu > li:last-child');

lastMobileFirstMenuItem.innerHTML = `<a href="#">
                                      Espace Membre
                                      <svg id="Groupe_1058" data-name="Groupe 1058" xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 32 32">
                                        <rect id="Rectangle_204" data-name="Rectangle 204" width="32" height="32" fill="#ee334e" opacity="0"/>
                                        <path id="Tracé_3229" data-name="Tracé 3229" d="M15.333,2A13.511,13.511,0,0,0,2,15.333,13.4,13.4,0,0,0,7.333,25.9V26h.136A12.929,12.929,0,0,0,23.2,26h.136v-.1a13.4,13.4,0,0,0,5.333-10.565A13.511,13.511,0,0,0,15.333,2ZM10.1,24.569A4,4,0,0,1,14,21.431h2.667a4,4,0,0,1,3.9,3.139,10.292,10.292,0,0,1-10.469,0Zm12.715-1.715a6.676,6.676,0,0,0-6.147-4.091H14a6.676,6.676,0,0,0-6.147,4.091,10.637,10.637,0,0,1-3.187-7.521A10.809,10.809,0,0,1,15.333,4.667,10.809,10.809,0,0,1,26,15.333,10.637,10.637,0,0,1,22.813,22.855Z" transform="translate(0.667 0.667)" fill="#ee334e"/>
                                        <path id="Tracé_3230" data-name="Tracé 3230" d="M13.333,6A5.217,5.217,0,0,0,8,11.333a5.217,5.217,0,0,0,5.333,5.333,5.217,5.217,0,0,0,5.333-5.333A5.217,5.217,0,0,0,13.333,6Zm0,8a2.551,2.551,0,0,1-2.667-2.667,2.551,2.551,0,0,1,2.667-2.667A2.551,2.551,0,0,1,16,11.333,2.551,2.551,0,0,1,13.333,14Z" transform="translate(2.667 2)" fill="#ee334e"/>
                                      </svg>
                                      </a>`;




const footerTitles = document.querySelectorAll('footer ul > li > a.title-wrapper');


footerTitles.forEach(el => el.onclick = function () {

  const parent = this.parentNode;
  parent.classList.toggle('is_active');

})



const menuPrimaryContainer = document.querySelector('.menu-primary-container');
const searchFormWrapper = document.querySelector('.desktop-search-bar');
const searchWrapper = document.querySelector('.search-wrapper');
const inputSubmit = document.querySelector('.desktop-search-wrapper .searchform > input[type="submit"]');
const closeSearchIcon = document.querySelector('.desktop-search-bar .close-search-icon');
const submitSearchIcon = document.querySelector('.desktop-search-bar .submit-search-icon');
const searchIcon = document.querySelector('#menu-primary .search-icon');

menuPrimaryContainer.insertAdjacentElement('afterbegin', searchWrapper);

searchIcon.parentNode.removeAttribute('href');


console.log(searchIcon.parentNode);

searchIcon.onclick = e => {
  searchFormWrapper.classList.add('active');
  document.querySelector('#menu-primary').classList.add('active');
}
closeSearchIcon.onclick = () => {
  searchFormWrapper.classList.remove('active');
  document.querySelector('#menu-primary').classList.remove('active');
}
submitSearchIcon.onclick = () => inputSubmit.click();






// WEBPACK FOOTER //
// ./scripts/common.js